import { ref, onMounted, onUnmounted } from 'vue';

export function useBreakpoint() {
  const isXs = ref(false);
  const isSm = ref(false);
  const isMd = ref(false);
  const isLg = ref(false);
  const isXl = ref(false);

  const breakpoints = {
    xs: '(max-width: 639px)',
    sm: '(min-width: 640px) and (max-width: 767px)',
    md: '(min-width: 768px) and (max-width: 1023px)',
    lg: '(min-width: 1024px) and (max-width: 1279px)',
    xl: '(min-width: 1280px)',
  };

  const updateBreakpoints = () => {
    isXs.value = window.matchMedia(breakpoints.xs).matches;
    isSm.value = window.matchMedia(breakpoints.sm).matches;
    isMd.value = window.matchMedia(breakpoints.md).matches;
    isLg.value = window.matchMedia(breakpoints.lg).matches;
    isXl.value = window.matchMedia(breakpoints.xl).matches;
  };

  const xsAndDown = () => isXs.value;
  const smAndUp = () => isSm.value || isMd.value || isLg.value || isXl.value;
  const smAndDown = () => isXs.value || isSm.value;
  const mdAndUp = () => isMd.value || isLg.value || isXl.value;
  const mdAndDown = () => isXs.value || isSm.value || isMd.value;
  const lgAndUp = () => isLg.value || isXl.value;
  const lgAndDown = () => isXs.value || isSm.value || isMd.value || isLg.value;

  onMounted(() => {
    updateBreakpoints();
    window.addEventListener('resize', updateBreakpoints);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateBreakpoints);
  });

  return {
    isXs, isSm, isMd, isLg, isXl,
    xsAndDown, smAndUp, smAndDown, mdAndUp, mdAndDown, lgAndUp, lgAndDown
  };
}
